// Central content management for all pages
// Edit text content here to update across the application

export const aboutPageContent = {
  title: "About the Singularity Countdown",
  
  intro: "The Singularity Countdown tracks futurist predictions leading up to the Technological Singularity. It aggregates expert insights—primarily from Ray Kurzweil's books, The Singularity Is Near and The Singularity Is Nearer—to monitor our progress toward human-level AI Singularity and the technological milestones expected along the way.",
  
  sections: [
    {
      title: "",
      content: "Because expert predictions are often scattered across books, Reddit blogs, and YouTube interviews, getting a comprehensive overview of our scientific future is difficult. This project provides objective monitoring of these claims with easy filtering, allowing you to see exactly what is expected to come and when."
    }
  ]
};
